import React from "react";
import { ImageIcon } from "lucide-react";

export const cardBtnClass = "product-card-btn mt-3 h-9 w-full rounded-lg inline-flex items-center justify-center gap-1.5 text-xs font-semibold whitespace-nowrap";

export function ProductCard({ image, alt = "", title, description, price, priceSub, meta, tagLeft, tagRight,
                              badge, action, priceTestid, highlight = false, testid, className = "", ...rest }) {
  return (
    <div className={`product-card group flex flex-col h-full min-w-0 rounded-2xl overflow-hidden ${className}`}
         style={highlight ? { boxShadow: "0 0 0 2px var(--gold), var(--card-shadow)" } : undefined}
         data-testid={testid} {...rest}>
      <div className="relative aspect-square overflow-hidden" style={{ background: "var(--bg-soft)" }}>
        {image ? <img src={image} alt={alt || title} loading="lazy" decoding="async"
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" />
          : <div className="h-full w-full grid place-items-center" style={{ color: "var(--text-muted)" }} data-testid="offer-image-placeholder">
              <ImageIcon className="h-7 w-7 opacity-50" /></div>}
        {tagLeft && <div className="absolute top-2 left-2">{tagLeft}</div>}
        {tagRight && <div className="absolute top-2 right-2 left-2 flex justify-end">{tagRight}</div>}
      </div>
      <div className="p-3 sm:p-4 flex flex-col flex-1">
        {badge}
        <div className="font-bold text-sm sm:text-[15px] leading-snug line-clamp-2" style={{ color: "var(--navy)" }}>{title}</div>
        {description && <p className="mt-1 text-xs leading-relaxed line-clamp-3" style={{ color: "var(--text-muted)" }}>{description}</p>}
        {meta && <div className="mt-1 text-[10px] tracking-wide uppercase" style={{ color: "var(--text-muted)" }}>{meta}</div>}
        <div className="mt-auto pt-2">
          {price && <div className="font-bold text-base leading-tight" style={{ color: "var(--navy)" }} data-testid={priceTestid}>{price}</div>}
          {price && priceSub && <div className="text-[10px]" style={{ color: "var(--text-muted)" }}>{priceSub}</div>}
          {action}
        </div>
      </div>
    </div>
  );
}

export const CardTag = ({ children, gold = false, testid }) => (
  <span className="inline-flex items-center gap-1 max-w-full whitespace-nowrap overflow-hidden text-[9px] font-bold tracking-widest uppercase px-2 py-0.5 rounded-full"
        style={gold ? { background: "var(--gold)", color: "var(--navy)" } : { background: "var(--navy)", color: "#fff" }}
        data-testid={testid}>{children}</span>
);
